import {
  SET_STORAGE_MANAGEMENT,
  SET_LINK_MOUNT_LIST,
  SET_LINK_MOUNT_QUERY,
  SET_LINK_MOUNT_PAGE_NUM,
  SET_LINK_MOUNT_PAGE_SIZE,
  SET_TRANSFER_TASK,
  SET_LEISU_VERSION,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
})
const state = {
  list: [],
  leisuVersion: '', // 雷速版本
  transferTaskList: [],
  query: initQuery(),
  linkMountList: {
    items: [],
    total: 0,
    pageNum: 1,
    pageSize: 5,
  },
  linkMountQuery: {
    sourceUserId: '',
    linkUserId: '',
    pageNum: 1,
    pageSize: 5,
  },
}

const mutations = {
  [SET_STORAGE_MANAGEMENT] (state, payload) {
    state.list = payload
  },
  [SET_LINK_MOUNT_LIST] (state, payload) {
    state.linkMountList = payload
  },
  [SET_LINK_MOUNT_QUERY] (state, payload) {
    state.linkMountQuery = {
      ...state.linkMountQuery,
      ...payload,
    }
  },
  [SET_LINK_MOUNT_PAGE_NUM] (state, payload) {
    state.linkMountQuery.pageNum = payload
  },
  [SET_LINK_MOUNT_PAGE_SIZE] (state, payload) {
    state.linkMountQuery.pageSize = payload
  },
  [SET_TRANSFER_TASK] (state, payload) {
    state.transferTaskList = payload
  },
  [SET_LEISU_VERSION] (state, payload) {
    state.leisuVersion = payload
  },
}

const actions = {
  // 存储管理列表
  async queryByCondition ({state, commit}, payload) {
    let query = {}
    _.forIn(state.query, (v, k) => {
      if (v !== '') query[k] = v
    })
    let params = {
      ...query,
      ...payload,
    }
    for (let i in params) {
      if (params[i] === '') delete params[i]
    }
    let data = await api.storageApi.queryByCondition(params)
    commit(SET_STORAGE_MANAGEMENT, data.data)
  },
  // 添加存储管理
  async addMountPath ({dispatch}, payload) {
    let data = await api.storageApi.addMountPath(payload)
    if (data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
  // 删除存储
  async deleteMountPath ({dispatch}, payload) {
    let data = await api.storageApi.deleteMountPath(payload)
    if (data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
   // 编辑存储
  async updateMountPath ({dispatch}, payload) {
    let data = await api.storageApi.updateMountPath(payload)
    if (data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
  // 新建转移任务
  async generateTransferTask ({dispatch}, payload) {
    let data = await api.storageApi.generateTransferTask(payload)
    if (data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
  // 获取转移任务列表
  async getTransferTaskList ({state, commit}, payload) {
    let query = {}
    _.forIn(state.query, (v, k) => {
      if (v !== '') query[k] = v
    })
    let params = {
      ...query,
      ...payload,
    }
    let data = await api.storageApi.getTransferTaskList(params)
    commit(SET_TRANSFER_TASK, data.data)
  },
  // 删除转移任务
  async deleteTransferTask ({dispatch}, payload) {
    let data = await api.storageApi.deleteTransferTask(payload)
    if (data.code === 200) {
      dispatch('getTransferTaskList')
    }
    return data
  },
  // 清空存储
  async deleteStorageListCache ({dispatch}, payload) {
    let data = await api.storageApi.deleteStorageListCache(payload)
    return data
  },
   // 设置雷速版本
  async setRaySyncClientVersion ({dispatch}, payload) {
    let data = await api.storageApi.setRaySyncClientVersion(payload)
    if (data.code === 200) {
      dispatch('getRaySyncClientVersion')
    }
    return data
  },
   // 获取雷速版本
  async getRaySyncClientVersion ({commit}, payload) {
    let data = await api.storageApi.getRaySyncClientVersion(payload)
    commit(SET_LEISU_VERSION, data.data)
    return data
  },
  // 查询存储吞吐带宽
  async queryBandwidth ({commit}, payload) {
    let res = await api.storageApi.queryBandwidth(payload)
    return res
  },
  // 修改存储吞吐带宽
  async editBandwidth ({dispatch}, payload) {
    let res = await api.storageApi.editBandwidth(payload)
    if (res.code === 200) {
      dispatch('queryByCondition')
    }
    return res
  },
  async queryLinkMountList ({state, commit}, payload) {
    let params = {
      ...state.linkMountQuery,
      ...payload,
    }
    for (let i in params) {
      if (params[i] === '') delete params[i]
    }
    let data = await api.storageApi.queryLinkMountList(params)
    if (data.code === 200) {
      commit(SET_LINK_MOUNT_LIST, data.data)
      commit(SET_LINK_MOUNT_QUERY, {
        pageNum: data.data.pageNum,
        pageSize: data.data.pageSize,
      })
    }
    return data
  },
  async addLinkMount ({dispatch}, payload) {
    let data = await api.storageApi.addLinkMount(payload)
    if (data.code === 200) {
      dispatch('queryLinkMountList', {pageNum: 1})
    }
    return data
  },
  async updateLinkMount ({dispatch}, payload) {
    let data = await api.storageApi.updateLinkMount(payload)
    if (data.code === 200) {
      dispatch('queryLinkMountList')
    }
    return data
  },
  async deleteLinkMount ({dispatch, state, commit}, payload) {
    let data = await api.storageApi.deleteLinkMount(payload)
    if (data.code === 200) {
      const currentPageEmpty = state.linkMountList.items.length <= payload.ids.length && state.linkMountQuery.pageNum > 1
      if (currentPageEmpty) {
        commit(SET_LINK_MOUNT_PAGE_NUM, state.linkMountQuery.pageNum - 1)
      }
      dispatch('queryLinkMountList')
    }
    return data
  },
  setLinkMountQuery ({commit}, payload) {
    commit(SET_LINK_MOUNT_QUERY, payload)
  },
  setLinkMountPageNum ({commit}, payload) {
    commit(SET_LINK_MOUNT_PAGE_NUM, payload)
  },
  setLinkMountPageSize ({commit}, payload) {
    commit(SET_LINK_MOUNT_PAGE_SIZE, payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
